// extracted by mini-css-extract-plugin
export default {"gridRow":"GridRow__gridRow___swOCsJvE"};